import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { object, string } from 'yup';
import { useNavigate } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from '@mui/material';
import { TextInput } from '../Helpers/Inputs';
import { emptyStringToUndefined } from '../Helpers/Formatters/EmptyStringToUndefined';
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem, storeConsumerApplicationId, SESSION_STORAGE_AFLAC_QUOTE } from '../../sessionStorage';

export default function RetrieveProgress() {
  const formMethods = useForm({
    resolver: yupResolver(RetrieveProgress.ValidationSchema),
    mode: 'all',
    reValidateMode: 'all',
  });
  const { handleSubmit, register, setValue } = formMethods;

  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [pin, setPin] = useState('');
  const SESSION_STORAGE_KEY = 'AMERICO_QUOTE';
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleEmailChange = value => {
    setValue('email', value);
    setEmail(value);
  };

  const handlePinChange = value => {
    setValue('pin', value);
    setPin(value);
  };

  useEffect(() => {
    register('email');
    setValue('email', email);
    register('pin');
    setValue('pin', pin);
  }, []);

  const onNext = () => {
    setLoading(true);
    setMessage('');

    const appId = new URLSearchParams(window.location.search).get('appId');

    const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;

    fetch(`${covrServicesUrl}/api/ConsumerApplication/Get?email=${encodeURIComponent(email)}&pin=${pin}&appId=${appId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId,
      }
    })
      .then(storeConsumerApplicationId)
      .then(data => {
        if (data.appData !== null && data.appData.includes('currentStep')) {
          if (data.productType === "Supplemental Health") {
            sessionStorage.setItem(SESSION_STORAGE_AFLAC_QUOTE, data.appData);
            navigate(`/quote/aflac/hospital-confinement/`);
          }
          else {
            sessionStorage.setItem(SESSION_STORAGE_KEY, data.appData);
            navigate(`/loan-protection/`);
          }
        } else {
          setMessage('No progress was found for that Email and PIN.');
        }
        setLoading(false);
      });
  };

  return (
    <Container>
      <Row className="formPage justify-content-center">
        <Col lg={6} className='w-100'>
          <FormProvider {...formMethods}>
            <Form onSubmit={handleSubmit(onNext)}>
              <br />
              <br />
              <h3>Retrieve Progress</h3>
              Enter the email and PIN set on a prior application to retrieve progress.<br />
              <br />
              <TextInput
                id="email"
                name="email"
                label="Email Address"
                value={email}
                onChange={e => handleEmailChange(e.target.value)}
              />
              <br />
              <br />
              <TextInput
                id="pin"
                type="password"
                name="pin"
                label="4 Digit PIN"
                value={pin}
                onChange={e => handlePinChange(e.target.value)}
                inputProps={{
                  maxLength: 4
                }}
              />
              <br />
              <br />
              <Button disabled={loading} type="submit" variant="contained" color="primary">
                Continue
              </Button>
              <br />
              <br />
              {message}
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
            </Form>
          </FormProvider>
        </Col>
      </Row>
    </Container>
  );
}

RetrieveProgress.ValidationSchema = object().shape({
  email: string()
    .transform(emptyStringToUndefined)
    .email('Invalid email')
    .required('Email is required'),
  pin: string()
    .transform(emptyStringToUndefined)
    .required('PIN is required')
    .length(4)
    .matches(/\d{4}/, 'PIN must be 4 numeric digits'),
});

RetrieveProgress.DefaultFormState = {
  email: '',
  pin: '',
};
